import { render, staticRenderFns } from "./EmailForm.vue?vue&type=template&id=4b7a9128&scoped=true&"
import script from "./EmailForm.vue?vue&type=script&lang=js&"
export * from "./EmailForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailForm.vue?vue&type=style&index=0&id=4b7a9128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a9128",
  null
  
)

export default component.exports